<template>
	<div>
		<innovationCenNav ref="innovationCenNav" :list="navList" @goScroll="goScroll" v-show="cenNavHidden"></innovationCenNav>
		<div class="innovBox">
			<div v-for="(item,index) in innovationList" :key="index">
				<indexTitle :ref="'in'+item.id" :title="item.name" v-if="item.banners.length>0" :more="false"></indexTitle>
				<innovationCenSwiper :indexa="index" :list='item.banners' v-if="item.banners.length>0" @goDetail="event=>goDetail(event,item)"></innovationCenSwiper>
			</div>
			<!-- <indexTitle ref="cxts" :title="$t('高兼容性')"></indexTitle>
			<innovationCenSwiper ref="cxtsSwiper" :list='cxtsList'></innovationCenSwiper>
			<indexTitle ref="xxjs" :title="$t('配套产品')"></indexTitle>
			<innovationCenSwiper ref="xxjsSwiper" :list='xxjsList'></innovationCenSwiper>
			<indexTitle ref="zzgx" :title="$t('多场景运用')"></indexTitle>
			<innovationCenSwiper ref="zzgxSwiper" :list='zzgxList'></innovationCenSwiper>
			<indexTitle ref="sjqy" :title="$t('高效内镜平台')"></indexTitle>
			<innovationCenSwiper ref="sjqySwiper" :list='sjqyList'></innovationCenSwiper> -->
		</div>
		
	</div>
</template>

<script>
	import innovationCenNav from "./innovationCenNav"
	import indexTitle from "./indexTitle"
	import innovationCenSwiper from "./innovationCenSwiper"
	export default {
		components: {
			innovationCenNav,
			indexTitle,
			innovationCenSwiper
		},
		data() {
			return {
				navList: [
					// {
					// 	name: this.$t('功能强大'),
					// 	value: 'qb',
					// },
					// {
					// 	name: this.$t('头端LED光源'),
					// 	value: 'cxts',
					// },
					// {
					// 	name: this.$t('配套产品'),
					// 	value: 'xxjs',
					// },
					// {
					// 	name: this.$t('清晰画质'),
					// 	value: 'zzgx',
					// },
					// {
					// 	name: this.$t('功能强大'),
					// 	value: 'sjqy',
					// },
				],
				navHidden: false,
				scrollTop: 0,
				scrollTopNav: 0,
				cenNavHidden: true,
				navTop:[],
				querValue:'',
				cxtsList:[
					{
						img:require("@/assets/content/banner.png"),
						name:'以4K答内镜图像「天花板」之问',
						cen:'软镜像素的极限在哪里？'
					},
					{
						img:require("@/assets/content/banner.png"),
						name:'以4K答内镜图像「天花板」之问',
						cen:'软镜像素的极限在哪里？'
					},
					{
						img:require("@/assets/content/banner.png"),
						name:'以4K答内镜图像「天花板」之问',
						cen:'软镜像素的极限在哪里？'
					}
				],
				xxjsList:[
					{
						img:require("@/assets/content/banner.png"),
						name:'以4K答内镜图像「天花板」之问',
						cen:'软镜像素的极限在哪里？'
					},
					{
						img:require("@/assets/content/banner.png"),
						name:'以4K答内镜图像「天花板」之问',
						cen:'软镜像素的极限在哪里？'
					},
					{
						img:require("@/assets/content/banner.png"),
						name:'以4K答内镜图像「天花板」之问',
						cen:'软镜像素的极限在哪里？'
					}
				],
				zzgxList:[
					{
						img:require("@/assets/content/banner.png"),
						name:'以4K答内镜图像「天花板」之问',
						cen:'软镜像素的极限在哪里？'
					},
					{
						img:require("@/assets/content/banner.png"),
						name:'以4K答内镜图像「天花板」之问',
						cen:'软镜像素的极限在哪里？'
					},
					{
						img:require("@/assets/content/banner.png"),
						name:'以4K答内镜图像「天花板」之问',
						cen:'软镜像素的极限在哪里？'
					}
				],
				sjqyList:[
					{
						img:require("@/assets/content/banner.png"),
						name:'以4K答内镜图像「天花板」之问',
						cen:'软镜像素的极限在哪里？'
					},
					{
						img:require("@/assets/content/banner.png"),
						name:'以4K答内镜图像「天花板」之问',
						cen:'软镜像素的极限在哪里？'
					},
					{
						img:require("@/assets/content/banner.png"),
						name:'以4K答内镜图像「天花板」之问',
						cen:'软镜像素的极限在哪里？'
					}
				],
				innovationList:[]
			}
		},
		watch: {
			scrollTop() {
				if (this.scrollTop < this.scrollTopNav) {
					this.cenNavHidden = true;
				}
				this.navList.map((v,a)=>{
					if(this.scrollTop==0){
						this.$refs.innovationCenNav.current=0;
						return;
					}
					if(a+1==this.navList.length){
						if ((this.scrollTop+70) > this.navTop[a]) {
							this.$refs.innovationCenNav.current=a;
						}
					}else{
						if ((this.scrollTop+70) > this.navTop[a]&&(this.scrollTop+70)< this.navTop[a+1]) {
							this.$refs.innovationCenNav.current=a;
						}
					}
					
					// if(!this.navHidden){
					// 	if (offsetTop > this.navTop[a]&&offsetTop< this.navTop[a+1]) {
					// 		this.$refs.innovationCenNav.current=a;
					// 	}
					// 	return;
					// }
					// if (offsetTop > this.scrollTop) {
					// 	this.$refs.innovationCenNav.current=a
					// }
				})
			},
			querValue(){
				let t=this;
				console.log(this.querValue)
				this.$nextTick(function(){
					t.setTop();
				})
			},
			navList(){
				this.$nextTick(function(){
					this.getTop();
				})
			},
			navTop(){
				let t=this;
				t.querValue=this.$route.query.value;
				t.setTop();
			}
		},
		
		mounted() {
			let t=this;
			let offsetTop = this.$refs.innovationCenNav.$el.offsetTop;
			this.scrollTopNav = offsetTop;
			window.addEventListener('scroll', this.handleScroll);
			this.querValue=this.$route.query.value;
			this.$nextTick(function(){
				var element;
				if(this.nowVibe=='pc'){
					element= document.documentElement
				}else{
					element = document.documentElement.scrollTop ? document.documentElement : document.body;
				}
				t.scrollTop = element.scrollTop;
				// t.getTop();
			})
			
			console.log(this.querValue,"嗷嗷")
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		methods: {
			setTop(){
				let value=this.querValue;
				if(value=='cxts'){
					value='in1'
				}
				if(value=='xxjs'){
					value='in2'
				}
				if(value=='zzgx'){
					value='in3'
				}
				if(value=='sjqy'){
					value='in4'
				}
				this.navList.map((v,a)=>{
					if(value==v.value){
						this.$refs.innovationCenNav.current=a;
					}
					
				})
				this.goScroll(this.querValue)
			},
			getTop(){
				let top=[];
				if(this.navList.length<1){
					return
				}
				this.navList.map((v,a)=>{
					if(v.value=='in0'){
						top.push('')
					}else{
						top.push(this.$refs[v.value][0].$el.offsetTop)
						console.log(top)
					}
				})
				this.$nextTick(function(){
					this.navTop=top;
				})
				console.log(this.navTop)
			},
			goScroll(e) {
				console.log(e)
				
				if(e=='in0'){
					// document.documentElement.scrollTop = 0;
					var element;
					if(this.nowVibe=='pc'){
						element= document.documentElement
					}else{
						element = document.documentElement.scrollTop ? document.documentElement : document.body;
					}
					element.scrollTop =0;
					return;
				}
				if(e=='cxts'){
					e='in1'
				}
				if(e=='xxjs'){
					e='in2'
				}
				if(e=='zzgx'){
					e='in3'
				}
				if(e=='sjqy'){
					e='in4'
				}
				if(this.$refs[e]){
					let offsetTop = this.$refs[e][0].$el.offsetTop - 70;
					this.$emit('goScroll',offsetTop)
				}
				
			},
			handleScroll(e) {
				var element;
				if(this.nowVibe=='pc'){
					element= document.documentElement
				}else{
					element = document.documentElement.scrollTop ? document.documentElement : document.body;
				}
				this.scrollTop = element.scrollTop;
			},
			setList(e){
				console.log(e)
				let list=[]
				e.forEach(v=>{
					list.push({value:'in'+v.id,name:v.name})
				})
				this.$nextTick(function(){
					this.navList=list;
					this.innovationList=e;
				})
				
			},
			goDetail(e,a){
				console.log(e,a)
				this.$router.push({
					path:'/innovationDetail',
					name:'innovationDetail',
					query:{
						id:a.id,
						infoId:e.id
					}
				})
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.innovBox{
		width: 1200px;
		margin: 0 auto;
		padding-top: 60px;
	}
	@media screen and (max-width:1200px) {
		.innovBox{
			width: 100% !important;
			padding-top: 30px !important;
		}
	}
</style>